import { render } from "./component-payer-checking-acc.vue?vue&type=template&id=01c0141a"
import script from "./component-payer-checking-acc.vue?vue&type=script&setup=true&lang=js"
export * from "./component-payer-checking-acc.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-payer-checking-acc.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01c0141a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01c0141a', __exports__)) {
    api.reload('01c0141a', __exports__)
  }
  
  module.hot.accept("./component-payer-checking-acc.vue?vue&type=template&id=01c0141a", () => {
    api.rerender('01c0141a', render)
  })

}


export default __exports__